import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import base_url from "../../api";
import "./VerifyEmail.css";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    
    console.log("Token from URL:", token ? token.substring(0, 20) + "..." : "No token");

    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link. No token provided.");
      return;
    }

    // Verify the email
    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      // URL encode the token to handle special characters
      const encodedToken = encodeURIComponent(token);
      const url = `${base_url}/verify-email?token=${encodedToken}`;
      
      console.log("Verifying email with URL:", url);
      console.log("Token (first 20 chars):", token.substring(0, 20));
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      
      console.log("Verification response:", data);

      if (response.ok) {
        setStatus("success");
        setMessage(data.message || "Email verified successfully!");
        
        toast.success(data.message || "Email verified successfully! You can now login.", {
          position: "top-right",
          autoClose: 3000,
        });

        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setStatus("error");
        setMessage(data.message || "Verification failed. Please try again.");
        
        toast.error(data.message || "Verification failed.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      setStatus("error");
      setMessage("Something went wrong. Please try again later.");
      
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  const handleResendEmail = async () => {
    if (!email) {
      toast.error("Please enter your email address.", {
        position: "top-right",
      });
      return;
    }

    try {
      const response = await fetch(`${base_url}/verify-email/resend`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "Verification email sent successfully!", {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error(data.message || "Failed to send verification email.", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
      });
    }
  };

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        {status === "verifying" && (
          <div className="verify-status verifying">
            <div className="spinner"></div>
            <h2>Verifying your email...</h2>
            <p>Please wait while we verify your email address.</p>
          </div>
        )}

        {status === "success" && (
          <div className="verify-status success">
            <div className="success-icon">✓</div>
            <h2>Email Verified!</h2>
            <p>{message}</p>
            <p className="redirect-message">Redirecting to login page...</p>
            <button className="btn btn-primary" onClick={() => navigate("/login")}>
              Go to Login
            </button>
          </div>
        )}

        {status === "error" && (
          <div className="verify-status error">
            <div className="error-icon">✗</div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <div className="resend-section">
              <p>Didn't receive the email or link expired?</p>
              <div className="resend-form">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="resend-input"
                />
                <button className="btn btn-primary" onClick={handleResendEmail}>
                  Resend Verification Email
                </button>
              </div>
            </div>
            <button className="btn btn-secondary" onClick={() => navigate("/login")}>
              Go to Login
            </button>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default VerifyEmail;
